import { Constants } from '@leverege/api-redux';
import { Plugins } from '@leverege/plugin';

/* eslint-disable no-console */

function cleanupPreload() {
  const root = document.getElementById('preload-root');
  root?.parentElement?.removeChild(root);
}

/**
 * Creates and installs the ApiProvider
 */
const authInitPlugin = {
  id: 'molten.PreloadAuthInit',
  sort: 1,
  createMiddleware: molten => {
    return store => next => action => {
      // Trigger onLoggedIn Plugins. Wait for them to return
      // before sending the action
      if (action.type === Constants.AUTH_LOGGED_IN) {
        cleanupPreload();
      }
      return next(action);
    };
  }
};
Plugins.addPlugin('Molten.ReduxMiddleware', authInitPlugin);
export {
// eslint-disable-next-line import/prefer-default-export
cleanupPreload };